import React, { ReactElement } from "react";
import useFooterStyles, { FooterClasses } from "./styles";
import {
  InstagramIcon,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  YoutubeIcon,
  TrIcon,
  PlayStoreMultiColorIcon,
  AppleStoreWhiteIcon,
  EnIcon,
  AndroidIconGreen,
} from "../../../assets/img/svgicons";
import SideLinks from "./SideLinks";
import SocialNetworkLinks from "./SocialNetworkLinks";
import { useTranslation } from "react-i18next";
import LanguageSelection from "../../LanguageSelection";
import DownloadIconBuilder from "../../../components/DownloadIconBuilder";

export type FooterProps = {};

function Footer(): ReactElement {
  let width = window.innerWidth;
  let breakpoint = 768;
  // Translation
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const useStyles: FooterClasses = useFooterStyles({ lang });

  return (
    <footer className={useStyles.footer}>
      <div className={useStyles.wrapper}>
        <div className={useStyles.footerTop}>
          <div className={useStyles.footerTopLeft}>
            <div className={useStyles.logoBox}>
              <div className={useStyles.logo}></div>
            </div>
            {/*
            <div
              className={useStyles.downloadBox}
              style={width <= breakpoint ? { flexDirection: "column" } : {}}
            >
              <DownloadIconBuilder
                link="#"
                icon={<PlayStoreMultiColorIcon width="24" height="30" />}
                descText={"GET IN THE"}
                mainText={"GooglePlay"}
                padding="8px 22px 8px 10px"
                bgColor="#212227"
              />
              <div
                className={useStyles.divider}
                style={
                  width <= breakpoint
                    ? { width: "5px", height: "5px" }
                    : { width: "10px" }
                }
              ></div>
              <DownloadIconBuilder
                link="#"
                icon={<AppleStoreWhiteIcon width="22" height="30" />}
                descText={"Available on the"}
                mainText={"App Store"}
                padding="8px 35px 8px 10px"
                bgColor="#212227"
              />
              <div
                className={useStyles.divider}
                style={
                  width <= breakpoint
                    ? { width: "5px", height: "5px" }
                    : { width: "10px" }
                }
              ></div>
              <DownloadIconBuilder
                link="#"
                icon={<AndroidIconGreen width="26" height="26" />}
                descText={"Directly Download"}
                mainText={"For Free"}
                padding="10px 26px 10px 12px"
                bgColor="#212227"
              />
               <DownloadIconBuilder
                icon={<PlayStoreMultiColorIcon width="22" height="28" />}
                descText={"GET IN THE"}
                mainText={"GooglePlay"}
                mainTextSize="14px"
                descTextSize="7px"
                padding="0 26px 0 14px"
                bgColor="#212227"
                height="44px"
              />
              <div
                className="divider"
                style={
                  width <= breakpoint ? { width: "5px" } : { width: "20px" }
                }
              ></div>
              <DownloadIconBuilder
                icon={<AppleStoreWhiteIcon width="20" height="28" />}
                descText={"Available on the"}
                mainText={"App Store"}
                mainTextSize="14px"
                descTextSize="7px"
                padding="0 37px 0 14px"
                bgColor="#212227"
                height="44px"
              /> 
            </div>*/}
          </div>
          <div className={useStyles.footerTopRight}>
            <div className={useStyles.listItemsBox}>
              <ul className={useStyles.listItems}>
                <li className={useStyles.listItem}>
                  <a href="#" className={useStyles.listItemLink}>
                    {t("headerServicesText")}
                  </a>
                </li>
                <li className={useStyles.listItem}>
                  <a href="#" className={useStyles.listItemLink}>
                    {t("footerAboutUsText")}
                  </a>
                </li>
                <li className={useStyles.listItem}>
                  <a href="#" className={useStyles.listItemLink}>
                    {t("footerContactUsText")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={useStyles.footerCenter}>
          <div className={useStyles.languageBox}>
            {/*<LanguageSelection
              languages={[
                {
                  lang: "tr",
                  icon: <TrIcon width="21" />,
                  label: "Turkish",
                },
                {
                  lang: "en",
                  icon: <EnIcon />,
                  label: "English",
                  activeLang: true,
                },
              ]}
            />*/}
          </div>
          <div className={useStyles.socialNetworkBox}>
            <SocialNetworkLinks
              socialNetworks={[
                { icon: <InstagramIcon width="20px" />, link: "#" },
                { icon: <FacebookIcon width="10px" />, link: "#" },
                { icon: <LinkedinIcon width="18px" />, link: "#" },
                { icon: <TwitterIcon width="18px" />, link: "#" },
                { icon: <YoutubeIcon width="16px" />, link: "#" },
              ]}
            />
          </div>
        </div>
        <div className={useStyles.footerBottom}>
          <SideLinks
            links={[
              { title: t("websiteTermsText"), link: "#" },
              { title: t("legalAgreementsText"), link: "#" },
              { title: t("privacyPolicyText"), link: "#" },
              { title: t("complaintsText"), link: "#" },
            ]}
          />
          <div className={useStyles.descBox}>
            <p className={useStyles.description}>copyright@superpay 2020</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
